import _extends from "@babel/runtime/helpers/esm/extends";
import { createStore } from 'zustand';
import { createRegisteredContext } from 'react-singleton-context';
import { EModelEnv, createAxiosClientDeprecated } from '../utils';
const DEFAULT_PROPS = {
  env: EModelEnv.Staging,
  keyEnv: 'ui-packages:env',
  keyAuthToken: 'ui-packages:auth_token'
};
export function createModelStore(initProps) {
  const props = _extends({}, DEFAULT_PROPS, initProps);
  return createStore()(set => _extends({}, props, {
    axiosClient: createAxiosClientDeprecated(props.keyAuthToken, props.env),
    setAxiosClient: axiosClient => set(() => ({
      axiosClient
    })),
    setSocket: socket => set(() => ({
      socket
    })),
    setCurrentAuth: auth => set(() => ({
      auth
    }))
  }));
}
const ModelContext = createRegisteredContext('ModelContext', null);
export default ModelContext;